import React from "react";
import { OrderedListOutlined } from "@ant-design/icons";
import { DataTable } from "./DataTable";
import { YhBox } from "@components/YhBox";
import { Button } from "antd";
import { useRoleModel } from "../roleModel";
import { YhAuth } from "@src/components/auth/YhAuth";

export const DataBox = () => {
    const { setEditModel, setDrawerVisible } = useRoleModel();

    const onAdd = () => {
        setEditModel("add")
        setDrawerVisible(true)
    }

    const action = (
        <>
            <YhAuth resCode="portal2.au.role.ad">
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAdd}
                >新增</Button>
            </YhAuth>
            {/* <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => syncData()}
            >导出</Button> */}
        </>
    );

    return (
        <YhBox title={<OrderedListOutlined />} action={action}>
            <DataTable />
        </YhBox>
    )
}